"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailOpened = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var EmailOpened = function EmailOpened(_a) {
  var id = _a.id;
  var clipPathId = id ? "Users__clip0__".concat(id) : 'Users__clip0';
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("g", {
    clipPath: "url(#".concat(clipPathId, ")")
  }, react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M22.98 6.924l-9-6.3a3.456 3.456 0 00-3.96 0l-9 6.3A2.4 2.4 0 000 8.892V21.6A2.4 2.4 0 002.4 24h19.2a2.4 2.4 0 002.4-2.4V8.892a2.4 2.4 0 00-1.02-1.968zM12.6 15.192c-.178.117-.386.18-.6.18a1.02 1.02 0 01-.6-.192l-9-6.288 9-6.3a1.032 1.032 0 011.2 0l9 6.3-9 6.3z"
  })), react_1.default.createElement("defs", null, react_1.default.createElement("clipPath", {
    id: clipPathId
  }, react_1.default.createElement("path", {
    fill: "#fff",
    d: "M0 0H24V24H0z"
  }))));
};

exports.EmailOpened = EmailOpened;